<h1 mat-dialog-title> {{data.title}} </h1>
<div mat-dialog-content>
    {{data.bodyText}}
</div>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">
        Cancel
    </button>
    <button mat-button [mat-dialog-close]="true">
        {{confirmButtonLabel}}
    </button>
</mat-dialog-actions>